export default {
	chooseEffectiveTime: "选择生效时间",
	tips: {
		release: "是否确认发布该消息通知?",
		cancelRelease: "是否确认取消发布该消息通知?"
	}
};
